module.exports = __webpack_public_path__ + "img/choose-doctor.bb64f109.svg";